import { MessageCircle } from "lucide-react";
import { SITE, waLink, WA_DEFAULT_MSG } from "../config/site";

export const WhatsAppFloat = () => (
  <a
    href={waLink(WA_DEFAULT_MSG)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label={`Chat with ${SITE.name} on WhatsApp`}
    className="wa-pulse wa-float fixed right-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-900/30 transition-transform duration-300 hover:scale-110 sm:right-5 sm:h-14 sm:w-14"
  >
    <MessageCircle className="h-7 w-7" fill="currentColor" strokeWidth={0} />
    <span className="sr-only">Chat on WhatsApp</span>
  </a>
);
